import React from 'react';
import PageLayout from '../components/PageLayout';

/**
 * About Us page component
 */
const AboutPage: React.FC = () => {
  return (
    <PageLayout 
      title="About GolfScape" 
      subtitle="Making golf accessible and enjoyable for players of all levels"
      backgroundImage="https://images.pexels.com/photos/1325750/pexels-photo-1325750.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
    >
      <section>
        <h2>Our Story</h2>
        <p>
          Founded in 2023, GolfScape began with a simple mission: to make golf more accessible and enjoyable 
          for players of all skill levels. What started as a small booking platform for local golf courses 
          has grown into a comprehensive service connecting golfers with exceptional courses across the country.
        </p>
        <p>
          Our founder, Chris Martin, an avid golfer and technology enthusiast, recognized that booking tee times 
          often involved outdated systems, phone calls, and uncertainty about availability. He envisioned a 
          streamlined platform where golfers could easily browse courses, check real-time availability, and book 
          their perfect tee time with just a few clicks.
        </p>
      </section>
      
      <section>
        <h2>Our Mission</h2>
        <p>
          At GolfScape, we're committed to:
        </p>
        <ul>
          <li><strong>Simplifying the booking process</strong> - Making it effortless to find and reserve tee times</li>
          <li><strong>Supporting golf communities</strong> - Partnering with courses to help them thrive</li>
          <li><strong>Promoting the sport</strong> - Making golf more accessible to new players</li>
          <li><strong>Enhancing the experience</strong> - Providing valuable information and resources for golfers</li>
        </ul>
      </section>
      
      <section>
        <h2>Our Team</h2>
        <div className="two-column-content">
          <div className="content-card">
            <h3>Leadership</h3>
            <p>
              Our leadership team brings together expertise in golf, technology, and customer service. 
              With decades of combined experience, they guide our company's vision and ensure we 
              deliver exceptional value to both golfers and course partners.
            </p>
            <ul>
              <li>Chris Martin - Founder & CEO</li>
              <li>Sarah Johnson - Chief Operations Officer</li>
              <li>Michael Williams - Chief Technology Officer</li>
              <li>Jessica Chen - VP of Golf Partnerships</li>
            </ul>
          </div>
          
          <div className="content-card">
            <h3>Our Experts</h3>
            <p>
              We're proud to work with golf professionals who contribute their expertise to our content, 
              course reviews, and recommendations. Their insights help our users improve their game and 
              make informed decisions about where to play.
            </p>
            <ul>
              <li>Tom Richards - PGA Professional</li>
              <li>Lisa Chen - Short Game Specialist</li>
              <li>Robert Taylor - Putting Coach</li>
              <li>Dr. James Wilson - Sports Psychology Consultant</li>
            </ul>
          </div>
        </div>
      </section>
      
      <section>
        <h2>Our Partners</h2>
        <p>
          We're proud to partner with over 200 golf courses nationwide, ranging from prestigious 
          championship venues to welcoming local clubs. Our partnerships allow us to offer exclusive 
          deals and ensure up-to-date information for all our listings.
        </p>
        <p>
          We also work with golf equipment manufacturers, training academies, and other industry 
          organizations to provide comprehensive resources for our golfing community.
        </p>
      </section>
      
      <section>
        <h2>Join Our Community</h2>
        <p>
          Whether you're a seasoned golfer or just getting started, we invite you to join the 
          GolfScape community. Book your next round, explore our tips and guides, or reach out to 
          learn more about partnering with us.
        </p>
        <p>
          Thank you for being part of our journey to make golf more accessible and enjoyable for everyone.
        </p>
      </section>
    </PageLayout>
  );
};

export default AboutPage;
